import React from "react";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import moment from "moment";
import { formatDateAsDateFormat } from "./spaBooking3";

function SpaBooking3c(props) {
  const { t } = props;

  function getAllTechnician() {
    const availableTechnician = [];

    props.technicianAvailableData.forEach((data) => {
      const dateAvailable_ = data.availableDate;
      data.results.forEach((d) => {
        availableTechnician.push({
          technicianId: d.technicianId,
          technicianName:
            d.technicianName ||
            (d.technician && d.technician.fullNameDisplayed) ||
            `${d.technician.firstName ? d.technician.firstName : ""} ${
              d.technician.lastName ? d.technician.lastName : ""
            }`,
          availableDate: dateAvailable_,
          technicianPrice: d.price,
        });
      });
    });
    return availableTechnician;
  }

  const handleBack = () => {
    props.goBack();
  };

  useEffect(() => {
    console.log(getAllTechnician(), "getAllTechnician");
  }, []);

  useEffect(() => {
    console.log(
      JSON.stringify(props.selectedTechnicianDetails, null, 2),
      "selectedTechnician"
    );
    console.log("SpaBooking3c", props);
  }, [props.selectedTechnicianDetails]);

  return (
    <>
      <section class="widgets spa-listing spa-details">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">{t(`spaBooking.heading3c`)}</div>
        </div>

        <div class="widgets">
          <div class="row margin-bottom-2">
            <div class="row">
              <div class="col">
                <div class="detail-body stay-body">
                  <form>
                    <div class="form-row">
                      <p class="heading">Available Times</p>
                      <div class="form-options">
                        {getAllTechnician().map((technician) => {
                          return (
                            <label>
                              <input
                                type="radio"
                                name="Times"
                                value={JSON.stringify(technician)}
                                checked={
                                  JSON.stringify(
                                    props.selectedTechnicianDetails
                                  ) == JSON.stringify(technician)
                                }
                                onChange={(e) => {
                                  console.log("log e", e);
                                  console.log(JSON.parse(e.target.value));
                                  props.setSelectedTechnicianDetails(
                                    JSON.parse(e.target.value)
                                  );
                                }}
                              />
                              <div>
                                <p>
                                  {`${formatDateAsDateFormat(
                                    technician.availableDate,
                                    props.dateFormat
                                  )}-${technician.technicianName}`}
                                </p>
                                <p></p>
                              </div>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-controls">
                <button
                  disabled={!props.selectedTechnicianDetails}
                  onClick={() =>
                    props.handleNextToSummaryPage(
                      props.selectedTechnicianDetails
                    )
                  }
                >
                  Continue
                </button>
                <button onClick={handleBack}>back</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
  };
};
export default connect(mapStateToProps)(
  withTranslation("translations")(SpaBooking3c)
);
